import React from 'react';
import { useSearchParams } from 'react-router-dom';
import * as authentikOidc from '../auth/authentikOidc';
import './PaymentSuccess.css';

/**
 * SignupExisting, migration landing page for existing customers (Flow B).
 *
 * Reached via an email-blast link like /signup-existing?email=tijn@example.com
 * announcing the move from Auth0 to Authentik. The Stripe subscription is
 * still active; the customer just needs to enroll a new password against
 * the same email.
 */
export default function SignupExisting() {
  const [searchParams] = useSearchParams();
  const email = searchParams.get('email') || '';

  const handleSignup = () => {
    authentikOidc.login({
      email,
      flow: 'enrollment',
      returnTo: '/app',
    });
  };

  return (
    <div className="ps-page">
      <div className="ps-card">
        <div className="ps-icon-wrapper success">
          <span className="material-icons">waving_hand</span>
        </div>

        <h1 className="ps-title">Welkom terug bij Humanaize Matcher</h1>

        <p className="ps-subtitle">
          We zijn overgestapt op een nieuw account-systeem. Je abonnement
          blijft gewoon actief, maar je moet eenmalig opnieuw een account
          aanmaken
          {email ? ` met dit e-mailadres: ${email}` : ''}.
        </p>

        <p style={{ marginTop: 0, marginBottom: 24, color: '#64748b', fontSize: '0.95rem' }}>
          Het duurt minder dan een minuut. Daarna heb je weer toegang tot al
          je tools.
        </p>

        <div className="ps-actions">
          <button
            type="button"
            className="ps-button"
            onClick={handleSignup}
          >
            <span className="material-icons">person_add</span>
            Account aanmaken
          </button>
        </div>

        <div className="ps-support" style={{ marginTop: '28px' }}>
          <p>
            Vragen? Neem contact op met{' '}
            <a href="mailto:support@humanaize.nl">support@humanaize.nl</a>
          </p>
        </div>
      </div>
    </div>
  );
}
